import { RefObject } from 'react';

export enum FormMessageType {
  PreSubmit = 'PreSubmit',
  Submit = 'Submit',
  AfterSubmit = 'AfterSubmit',
  SetControl = 'SetControl',
}

const createFormSubmitHandler = (messageType: FormMessageType, callback: () => void) => {
  return (event: MessageEvent) => {
    if (event.data.type === messageType) {
      callback();
    }
  };
};

export const handleFormAfterSubmit = (callback: () => void) =>
  createFormSubmitHandler(FormMessageType.AfterSubmit, callback);

export const handleFormSubmit = (callback: () => void) =>
  createFormSubmitHandler(FormMessageType.Submit, callback);

export const handleFormPreSubmit = (callback: () => void) =>
  createFormSubmitHandler(FormMessageType.PreSubmit, callback);

export const postFormSubmit = (iframeRef: RefObject<HTMLIFrameElement>, data: unknown) => {
  if (!iframeRef.current) {
    return;
  }

  const iframe = iframeRef.current;
  iframe.contentWindow?.postMessage(
    {
      type: FormMessageType.Submit,
      data: data,
    },
    '*'
  );
};

export const setFormControlValue = (
  iframeRef: RefObject<HTMLIFrameElement>,
  controlName: string,
  value: unknown,
  propertyName: string = 'value'
) => {
  if (!iframeRef.current) {
    return;
  }

  const iframe = iframeRef.current;
  iframe.onload = () => {
    iframe.contentWindow?.postMessage(
      {
        type: FormMessageType.SetControl,
        controlName,
        propertyName,
        value,
      },
      '*'
    );
  };
};
